import MultiGradientThemeIcon from './MultiGradientThemeIcon';
import './style/index.less';

export default MultiGradientThemeIcon;
